module.exports = __webpack_public_path__ + "static/img/15.3fba066.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rz/15.jpg
// module id = FLVY
// module chunks = 0